import React, { useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import { Input, Box } from 'ui/acro'
import { DesktopSearchIcon } from '../../Icons/'
import _ from 'lodash'
import { useSearchSupportDocuments } from 'api'

const SearchInput = styled(Input)(() =>
  css({
    marginTop: '0',
    marginBottom: '0'
  })
)

const SearchResultItem = styled(Box)(() =>
  css({
    display: 'block',
    fontFamily: 'proxima-nova',
    textTransform: 'none',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    padding: '10px',
    ':hover, :focus': {
      backgroundColor: '#F2F2F2'
    }
  })
)
const SearchIconBox = styled(Box)(() =>
  css({
    height: '22px',
    '@media only screen and (max-width: 767px)': {
      svg: {
        fill: 'white'
      }
    }
  })
)

const SearchBox = () => {
  const [query, setQuery] = useState('')
  const arrayOfOptionRefs = []
  const { data, isLoading } = useSearchSupportDocuments(query)
  const selectRef = useRef()
  const setOptionRef = (element) => {
    if (element !== null) {
      arrayOfOptionRefs.push(element)
    }
  }
  const delayedChanged = useRef(
    _.debounce((query) => setQuery(query), 500)
  ).current

  const handleInputChange = (e) => {
    const q = e.target.value
    delayedChanged(q)
  }

  const handleInputKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      event.preventDefault()
      arrayOfOptionRefs[arrayOfOptionRefs.length - 1] &&
        arrayOfOptionRefs[arrayOfOptionRefs.length - 1].focus()
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      arrayOfOptionRefs[0] && arrayOfOptionRefs[0].focus()
    }
  }

  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      selectRef.current.focus()
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault()
      const next = index - 1
      const nextOption =
        arrayOfOptionRefs[next < 0 ? arrayOfOptionRefs.length - 1 : next]

      if (nextOption) {
        nextOption.focus()
      }
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      const next = index + 1
      arrayOfOptionRefs[next > arrayOfOptionRefs.length - 1 ? 0 : next].focus()
    }
  }

  return (
    <Box
      className='search-container'
      position='relative'
      display={['inline-flex', null, null]}
      width='100%'
      maxWidth='905px'
      margin='0 auto'
      maxHeight={['47px', 'none', 'none']}
    >
      <SearchInput
        defaultValue={query}
        placeholder={'Search FAQs'}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
      />
      <Box
        as='a'
        className='unstyled search-icon-container'
        position={[null, 'absolute', 'absolute']}
        right='0'
        top='0'
        backgroundColor={['black', 'transparent', 'transparent']}
        padding={['12.5px', null, null]}
        ml={['10px', null, null]}
        borderRadius={['4px', null, null]}
      >
        <SearchIconBox>
          <DesktopSearchIcon color={['white', 'black', 'black']} />
        </SearchIconBox>
      </Box>
      {query.length > 2 && isLoading && (
        <Box
          px={['12px']}
          py={['10px']}
          width='100%'
          backgroundColor='white'
          border='1px solid #DBDBDB'
          position='absolute'
          maxHeight={['20em', '20em', '24em', '20em']}
          overflow='auto'
          zIndex={1}
          top={['57px', null, null]}
        >
          <SearchResultItem as='a' className='unstyled'>
            {' '}
            Loading...{' '}
          </SearchResultItem>
        </Box>
      )}

      {query.length > 2 && data && data.data && (
        <Box
          px={['15px']}
          py={['10px']}
          width='100%'
          backgroundColor='white'
          border='1px solid #DBDBDB'
          position='absolute'
          maxHeight='20em'
          overflow='auto'
          ref={selectRef}
          zIndex={1}
          top={['57px', null, null]}
        >
          {data.data.length <= 0 && (
            <SearchResultItem as='a' className='unstyled'>
              {' '}
              No Results Found.{' '}
            </SearchResultItem>
          )}
          {data.data.map(({ fields }, index) => (
            <SearchResultItem
              key={fields.slug}
              as='a'
              className='unstyled'
              textAlign='left'
              ref={setOptionRef}
              href={`/support/${fields.category
                .toLowerCase()
                .replace(/\s/g, '-')}/${fields.slug}`}
              onKeyDown={(e) => handleKeyDown(e, index)}
            >
              {fields.title}
            </SearchResultItem>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default SearchBox
